<script setup>
import { computed } from 'vue';
import logoSource from '@/components/CustomIcons/GamebookLogoBlue.vue';
import logoSourceDark from '@/components/CustomIcons/GamebookLogoDark.vue';

const props = defineProps({
  dark: Boolean,
});

const SelectedLogo = computed(() => (props.dark ? logoSourceDark : logoSource));
</script>

<template>
  <component
    :is="SelectedLogo"
    alt="GameBook logo"
  />
</template>

<style scoped></style>
